<template>
  <div id="QA" v-show="showPage">
    <div class="QA-header">
      <div class="logo">
        <img src="../../assets/qalog01.png" alt="">
      </div>
      <div class="baiyinzhi">
        <img src="../../assets/qalog02.png" alt="">
      </div>
    </div>
    <!-- <div class="bg">
      <img src="../../assets/qabg.png" alt="">
    </div> -->
    <div class="QA-body">
      <div class="title">
        <div class="line"></div>
        <div class="icons">
          <span class="qmask">?</span>
          <span class="qtxt">问题回复</span>
          <img style="width: 33px;vertical-align: middle;margin-left: 10px;" src="../../assets/qa01.png" alt="">
        </div>
      </div>
      <!-- 问题 -->
      <div class="questions">
        <div :id="'Q'+item.id" :class="{'questions-item':true}" v-for="(item, index) in QAList" :key="index" @click="toggleHandler($event, item)">
          <div class="item-title">
            <span v-html="item.question"></span>
            <!-- 箭头 -->
            <div :class="{'triangle':true,'arrowRotate':item.expand, 'arrowRotateBack':item.toggleBack}" style="position:absolute;top:5px;right:10px"></div>
          </div>
          <div :class="{'answer-box':true, 'heightBig': item.expand, 'heightSmall': item.toggleBack}">
            <div class="audio-box">
              <audio :id="'mypkfit_' + item.id" class="mypkfit_audio">
                <source :src="baseUrl + '/api/Article/GetAudioFileByName?fileName=' + 'mypkfit_' + item.id + '.mp3'" type="audio/mp3">
                您的浏览器不支持 audio 元素。
              </audio>
              <!-- 播放 -->
              <span v-show="item.showAnswer" @click="playAudio($event, item)">
                <img v-show="item.stop" class="play-img" src="../../assets/FITmenu01.png" alt="" style="height: 26px;">
                <img v-show="!item.stop" class="play-img" src="../../assets/qapause.png" alt="" style="height: 26px;">
                <span class="play-txt">语音播放</span>
              </span>
            </div>
            <div class="item-answer" v-html="item.answer" v-show="item.showAnswer"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- iframe -->
    <div v-if="false">
      <iframe :src="iframeUrl" frameborder="0" style="width: 100%;"></iframe>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>
<script>
import agreeBookDialog from "../login/agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'myQA',
  data () {
    return {
      showPage: false,
      ABDialogShow:false,
      baseUrl: process.env.config.baseUrl,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      QAList: [
        {
          title: 'myPKFiT是否有增量回收率（IVR1h)的参数体现？增量回收率的算法和临床意义是什么？',
          question: 'myPKFiT是否有增量回收率（IVR1h)的参数体现？<br> 增量回收率的算法和临床意义是什么？',
          answer: ` myPKFiT和WAPPS均无该值体现，该值需在实际过程中计算。<br>
            IVR：In Vivo Recovery,体内回收率。该参数的计算是基于输注后的峰值活度除以预期的峰值活度<sup>1</sup> 。<br>
            算法：<br>
            IVR=输注后峰值活度/预期峰值活度。理想的IVR值为2，即进1单位FVIII，体内FVIII浓度提高2单位；但数据显示IVR临床差异度较大。<br>
            BCH单中心的IVR数据显示：64例重型HA患儿，IVR（1h)的中位数为1.8（范围1.1-3.8）IVR 1.1-1.5 31%；IVR1.5-2.0 40%； IVR 2.1-2.5 20%； IVR>2.5 9%<br>
            临床实践中的应用：提升的因子水平=因子浓度×IVR 例如，若根据临床需求需将因子水平调至80%，按照理论IVR=2计算，需补充40IU/Kg。但患者进行了PK检测，显示IVR=1.2，因此实际计算，需补充66.7IU/Kg。<br>
            临床意义：根据BCH经验，临床IVR测定非常重要。1. 可以根据患者个人的药代动力参数指导临床因子用量，制定预防治疗方案，使因子用量更精确，最终可以实现快速止血; 2. 围手术期，血友病A外科手术替代治疗时，需要同时考虑IVR及半衰期两个参数，从而制定因子使用方案<br>
            <br><sub>1. Barnes,C. Pediatr Blood Cancer，2013，60（Suppl 1）：S27-29</sub>`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 1
        },
        {
          title: 'myPKFIT与WAPPS关于Advate的PK数据有何差异？',
          question: 'myPKFIT与WAPPS关于Advate的PK数据有何差异？',
          answer: `1. 工具中Advate数据的差异：<br>
            <table style="border:solid #fff; border-width:1px 0px 0px 1px;">
              <thead>
                <th style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;"></th>
                <th style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">myPKFiT</th>
                <th style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">WAPPS</th>
              </thead>
              <tbody>
                <tr>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">建模数据</td>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">2035样本 ，236个体（ADVATE特有模型）<sup>1</sup><br>儿童数据：206样本，52个体（1-6岁）<sup>1</sup></td>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">总共878样本，289个体（其中仅25人for ADVATE）<sup>2，3</sup><br>ADVATE群体中未包含儿童数据（年龄范围15-62岁）<sup>2</sup></td>
                </tr>
                <tr>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">输出信息</td>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">清除率、稳态分布容积、FVIII半衰期、至基线1%以上的时间<sup>1</sup><br>基于以上结果可以根据临床需求设定目标谷浓度（例如5%）、给药间隔软件可因此计算提供相应治疗方案</td>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">终末半衰期、至5%、2%和1%活性的时间、输注后24、48和72小时的预期血浆水平<sup>2</sup></td>
                </tr>
                <tr>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">PK预测时效</td>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">实时</td>
                  <td style="border:solid #fff; border-width:0px 1px 1px 0px; padding:10px 0px;">1个工作日</td>
                </tr>
              </tbody>
            </table>
            2. 研究中不同工具对于PK参数预测的差异：<br>
            Preijers et al比较了39例(Advate 30，Kogenate 9）中重度血友病患者分别使用myPKFIT,WAPPS,NOMAN对于rFVIII PK参数预测的差异<sup>4</sup>。研究这采集了患者注射rFVIII 50IU/kg 后4, 24 and 48 小时的血样。其中使用myPKFiT为30例接受Advate的患者中的24例提供了PK参数，而WAPPS和NONMEM则为所有患者提供PK参数，myPKFIT,WAPPS和NONMEM测得的半衰期不同（P < 0.001），中位数分别为12.6  (n=24), 11.2 （n=30)和13（n=30)小时。为了维持注射后48小时的FVIII谷浓度大于0.01 IU mL的水平，myPKFiT和NONMEM 预测的剂量分别为 15.1 和11.0 IU/kg (p < 0.01, n =11) ，  WAPPS和NONMEM预测的剂量分别是9.0 和 8.0 IU/kg (p < 0.01, n =23）. 在使用科跃奇的9个患者中，WAPPS and NONMEM 预测的PK参数也不同，半衰期是 15.0 and 12.3 小时，FVIII浓度至0.05 IU/ML的时间分别是  69.2 and 60.8 小时(p < 0.01, n=9)。 然而,获得这些水平的建议剂量没有差别。所以，三种PK工具对rFVIII预测的PK参数和剂量不同。临床专家应该意识到，PK工具的选择可能会影响推荐剂量。<br>
            <br><sub>1. Björkman S et al. Blood. 2012;119(2):612-618;</sub><br><sub>2. McEneny-King A, et al.  JMIR Res Protoc. 2016 Dec 7;5(4):e232;</sub><br>
            <sub>3. Iorio A, et. al; JMIR Res Protoc. 2016 Dec 15;5(4):e239;</sub><br><sub>4. Thrombosis and Haemostasis Vol. 118 No. 3/2018</sub><br>`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 2
        },
        {
          title: 'myPKFiT能否能用于手术患者，有抑制物的患者？',
          question: 'myPKFiT能否能用于手术患者，有抑制物的患者？',
          answer: `手术患者建议术前行PK检测，围手术期，血友病A外科手术替代治疗时，需要同时考虑IVR及半衰期两个参数，从而制定因子使用方案。有PK指导血友病拔牙术<sup>1</sup>及膝关节置换术<sup>2</sup>病例报道，并且国际上已经有评估围手术期因子用量的popPK模型<sup>3</sup> 。利用FVIII的药代动力学参数可指导血友病A患者的围手术期个体化用药, 具有安全和节约凝血因子用量的优点<sup>4</sup>。<br>
            myPKFiT软件可以根据Advate的实验室数据和患者个人信息来估算个体的 PK参数，以此参数来计算出预防剂量，还可以根据患者的个人需要和治疗计划指导制定相关的Advate剂量以及用药间隔，以达到根据百因止产品说明书中提供的建议剂量，使患者个人的FVIII水平等于或高于特定阈值。<br>
            首先， myPKFiT软件获得美国FDA批准可用于生成针对16岁及以上、体重45公斤或以上患者的常规预防的推荐剂量
            和频率。说明该软件的使用仅针对制定预防治疗方案，因为myPKFIT的群体PK模型建模数据为中高剂量的常规预防
            方案和间隔，并不包括手术期间FVIII极大剂量的隔日甚至多次给药的情境，所以<strong>myPKFiT并无手术期间的使用推荐</strong>。
            其次，目前临床上包括手术在内的按需治疗剂量是基于体重计算的。然而，虽然不同给药剂量和间隔可能带来PK参数峰
            浓度，AUC,至谷浓度时间的不同，但是半衰期这一参数是相对恒定的（不排除手术等应激状态下参数可能存在变化），
            <strong>所以手术前预防治疗期间所得的半衰期应该具有一定的参考价值</strong>。<br>
            <br><sub>1. Liras A, Romeu L.BMJ Case Rep. 2019 Apr 8;12(4).</sub><br><sub>2. Preijers T, et al. BMJ Case Rep. 2019 Jan 14;12(1).</sub><br>
            <sub>3. Hazendonk H，et, al. Haematologica 2016; 101: 1159–69.</sub><br>
            <sub>4. 华宝来，翁习生，et al. 《中华医学会血液学分会第十三届全国血栓与止血学术会议暨“血栓栓塞性疾病（血栓与止血）基础与临床研究进展”论文摘要汇编及学习班讲义》2011年</sub><br>`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 3
        },
        {
          title: 'myPKFiT能否用于有抑制物的患者？',
          question: 'myPKFiT能否用于有抑制物的患者？<br>',
          answer: `<strong>ISTH-SSC建议抑制物阳性或既往抑制物阳性患者行PK检测<sup>1</sup></strong>，考虑ITI治疗标准<br>
            完全耐受：抑制物持续阴性(<0.6 BU／mL)，且FVIII回收率>66％，FⅧ半衰期>6 h。<br>
            部分耐受：ITI治疗33个月，抑制物检测阴性，但凝血因子回收率持续低于66％或半衰期持续低于6 h，患儿对凝血因子替代产生临床治疗反应，抑制物滴度不再升高。<br>
            部分HCP观点：抑制物阳性患者不建议行PK检测。抑制物的出现中和了FVIII的作用，有抑制物的病人在PK测定时，因为大量FVIII被机体内抗体中和，FVIII清除率增加，半衰期缩短。由于抑制物对FVIII的中和作用，抑制物阳性患者的PK数据并不能真实反映其体内FVIII代谢水平，参考价值不大。故myPKFIT不能用于抑制物阳性的患者来预测个体PK曲线。<br>
            <br><sub>1. Iorio A , et al. Journal of Thrombosis and Haemostasis, 2017, 15</sub>`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 4
        },
        {
          title: 'PK评估的频率推荐是多长时间评估一次？WAPPS是如何推荐的？',
          question: 'PK评估的频率推荐是多长时间评估一次？WAPPS是如何推荐的？',
          answer: `儿童患者凝血因子半衰期比成人短，IVR比成人小，清除率比成人高，且随年龄变化，因此PK检测的频率更高<sup>1，2</sup>。2017版北欧指南强调基于贝叶斯法的PK测定可以优化治疗方案，中重型血友病儿童推荐6个月监测一次PK，较大儿童或成人12个月监测一次，轻型3年监测一次。BCH经验中、重型患儿半年随访时稀疏采样（单点或两点法）监测PK。<br>
            成人应根据临床综合评估，主要考虑推荐中、重型HA，治疗效果不显著，会有突破性出血患者，需重新设定目标谷浓度，进行PK检测，根据个体PK参数调整治疗方案；<br>
            据了解，WAPPS推荐体重变化大于5%时需要行PK检测重新评估；鉴于患者的生理病理情况是动态变化的，建议根据临床需要及时进行评估。<br>
            <br><sub>1.李培敬，吴润晖. 中华血液学杂志，2014，35（9）：869-872</sub><br>
            <sub>2.陈振萍，方拥军. 中国实用儿科杂志，2017，32（1）：23-28</sub><br>
            <sub>3.Nordic hemophilia Guidelines, 2017</sub><br>`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 5
        },
        {
          title: '亚洲人群关于myPKFIT的验证数据如何，有无人种差异？',
          question: '亚洲人群关于myPKFIT的验证数据如何，有无人种差异？',
          answer: `尚无相关数据发表；
            对既往13项百因止研究（n=555, 亚裔=29）的PK人种差异进行分析，通过观察预测的一致性，认为群体PK模型可以很好地预测亚裔和非亚裔患者中的暴露量。<br>
            061301（中国PTP研究）药代动力学全分析集纳入了23例受试者（6例受试者来自6岁以下年龄组，5例受试者来自6-12岁年龄组，12例受试者来自12岁以上年龄组），采用通过一步法（主要分析）测得的FVIII数据进行分析。总体而言，研究人群的药代动力学特征与历史数据相比无明显差异。<br>
            验证数据集包括9名15---37岁参与临床研究061301的中国成人/青少年重型PTP血友病患者血浆FVIII活性的数据 (Advate注射后10分钟,30分钟,1、3、6，9,24,28,32小时的测量值)。中位体重为72 kg (min: 44 kg; max: 92) 中位剂量是45.5 IU/kg （41.3 IU/kg-50 IU/kg). FVIII活性测定采用一期法进行分析。其中有2位受试者测量值因缺少3-4小时时间点的FVIII活性测量值(myPKFiT用于ADVATE的推荐时间点)而未被纳入外部验证数据集。`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 6
        },
        {
          title: '两点法是否能确保准确率？',
          question: '两点法是否能确保准确率？<br>',
          answer: `新ISTH指南建议结合稀疏采样的群体PK分析<sup>1</sup><br>
            对于标准FVIII，采用两样本到三样本的方案，采样时间为4–48小时内至少间隔12小时（例如4–8小时、16–28小时和40–60小时）；提供信息最多的单个样本是24小时的样本。<br>
            <img style="width:100%;" src="./static/qa7-pic.png" alt="">
            即使是单个24小时FVIII水平也可为初始剂量定制提供足够的数据<sup>2</sup>，但是：<br>
            <strong>ISTH的SSC建议采集2-3份样本分析标准FVIII的个体PK特征</strong><br>
            <br><sub>1. Iorio A , et al. Journal of Thrombosis and Haemostasis, 2017, 15.</sub><br>
            <sub>2. Björkman S. Haemophilia. 2010;16(4):597–605; 2. Iorio A, et al. J Thromb Haemost. 2017;15(12):2461–2465</sub><br>`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 7
        },
        {
          title: 'myPKFiT的原理及对临床影响',
          question: 'myPKFiT的原理及对临床影响<br>',
          answer: `基本原理：popPK+稀疏采样（使用贝叶斯方法可以减少血液采样的需求）<br>
            对临床的影响：<br>
            FVIII PK的完整描述可以帮助设计适合个体患者的预防性治疗时间表<sup>1</sup><br>
            当与贝叶斯分析一起使用时，群体PK模型可以是一款有用的工具，通过使用更少的血液采样时间点估计PK参数，使得常规使用PK引导给药决策变得更加实用<sup>2</sup><br>
            参考PK结果制定治疗方案（频率、剂量），根据临床表现设定合理目标谷浓度。<br>
            <br><sub>1. Björkman S. Haemophilia. 2010;16(4):597–605.</sub><br>
            <sub>2. 药代动力学中的贝叶斯原理。http://www.rxkinetics.com/bayes.html。访问于2018年10月24日；</sub><br>
            <sub>3. 2.Björkman S et al. J Thromb Haemost 2013;11:180–182</sub><br`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 8
        },
        {
          title: 'myPKFIT上市后16岁以下的路径是否会被关闭，如果国内是关闭的，是否可以使用国外的平台测算？',
          question: 'myPKFIT上市后16岁以下的路径是否会被关闭，如果国内是关闭的，是否可以使用国外的平台测算？',
          answer: `myPKFiT在中国获批使用，用于如下条件的血友病A（无抑制物）患者：<br>
            -年龄大于等于16岁<br>
            -体重45-120KG之内`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 9
        },
        {
          title: '关于PK检测及试剂方面有没有援助支持项目？',
          question: '关于PK检测及试剂方面有没有援助支持项目？',
          answer: `正在与患者服务团队共同计划中，预计将和初保合作，在一些重点城市中援助一定量的PK检测（以援助检测费的形式）<br>
            同时也在探索一些第三方检测中心合作的可能`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 10
        },
        {
          title: '多学科MDT团队不成熟对于myPKFIT上市后的临床应用的影响？',
          question: '多学科MDT团队不成熟对于myPKFIT上市后的临床应用的影响？',
          answer: `需确认医院是否具备因子活性检测能力，或有固定合作的检测机构，以满足PK检测的基础条件<br>
            临床HCP认可个体化治疗理念<br>
            临床HCP/临床药师使用myPKFiT软件为患者定制个体化治疗方案`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 11
        },
        {
          title: '医院八因子检验技术待开发，该怎么办？',
          question: '医院八因子检验技术待开发，该怎么办？',
          answer: `Option1:临床提需求，推动检验科开展因子活性检验项目<br>
            Option2:寻求外部检验机构合作 （例如：区域检验中心，第三方检验中心，HTC中心等）`,
          expand: false,
          stop: true,
          toggleBack: false,
          showAnswer: false,
          id: 12
        }
      ],
      iframeUrl: '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      takedacode: this.$route.query.takedacode || ''
    }
  },
  components: { agreeBookDialog },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myQA?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
 }

     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }
    
    if (!localStorage.TaToken && !this.takedacode) {
      this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myQA?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          this.showPage = true
        })
      } else {
        this.openId = localStorage.openId
        this.showPage = true
      }
    }
    setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1500);
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    toggleHandler (e, item) {
      e.stopPropagation()
      item.expand = !item.expand
      if (!item.expand) {
        item.toggleBack = true
        window.setTimeout(() => {
          item.showAnswer = false
        }, 500)
        // 关闭当前语音
        let nodeId = 'mypkfit_' + item.id
        let currentAudio = document.getElementById(nodeId)
        if (!currentAudio.paused) {
          item.stop = true
          if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
            WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
              // 在这里拿到 e.err_msg, 这里面就包含了所有的网络类型
              // alert(res.err_msg);
              currentAudio.pause()
            })
          }
        }
      } else {
        // 展开问题 埋点
        let params = {
          openId: this.openId,
          behavior: '点击问题展开按钮-' + item.title
        }
        this.$axiox.post(`/api/Logs/AddUserBehavior`, params).then(res => {
          console.log(res, '展开问题 埋点')
        })
        item.toggleBack = false
        item.showAnswer = true
      }
    },
    playAudio (e, item) {
      e.stopPropagation()
      console.log(item, 'play')
      let nodeId = 'mypkfit_' + item.id
      let currentAudio = document.getElementById(nodeId)
      let allAudio = document.getElementsByClassName('mypkfit_audio')
      console.log(currentAudio)
      if (currentAudio.paused) {
        // 播放问题语音 埋点
        let params = {
          openId: this.openId,
          behavior: '点击问题语音播放按钮-' + item.title
        }
        this.$axiox.post(`/api/Logs/AddUserBehavior`, params).then(res => {
          console.log(res, '播放问题语音 埋点')
        })
        // 播放当前语音
        item.stop = false
        // currentAudio.play()
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
            // 在这里拿到 e.err_msg, 这里面就包含了所有的网络类型
            // alert(res.err_msg);
            currentAudio.play()
          })
        }
        // 暂停其他语音
        for (let i = 0; i < allAudio.length; i++) {
          if ((i + 1) != item.id) {
            this.QAList.forEach(val => {
              if (val.id != item.id) {
                val.stop = true
              }
            })
            allAudio[i].pause()
          }
        }
        this.$forceUpdate()
      } else {
        item.stop = true
        // currentAudio.pause()
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
          WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
            // 在这里拿到 e.err_msg, 这里面就包含了所有的网络类型
            // alert(res.err_msg);
            currentAudio.pause()
          })
        }
      }

    }
  }
}
</script>
<style scoped>
  #QA {
    width: 100%;
    /* height: 100vh; */
    background: url('../../assets/qabg.png') center 81px no-repeat, linear-gradient(to right,#630B69,#720E78);
    padding-bottom: 40px;
    background-size: 100%;
  }
  .bg {
    width: 100%;
    height: 200px;
  }
  .bg img{
    display: block;
    width: 100%;
  }
  .QA-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .logo {
    padding: 18px;
  }
  .logo img {
    display: block;
    width: 80px;
  }
  .baiyinzhi {
    padding: 12px;
  }
  .baiyinzhi img{
    display: block;
    width: 130px;
  }
  .QA-body {
    padding: 10px;
    /* padding-top: 20px; */
    background: url('../../assets/qabg.png') center bottom no-repeat;
    background-size: 100%;
  }
  .QA-body .title {
    position: relative;
    padding-left: 5px;
  }
  .QA-body .line {
    width: 90px;
    height: 20px;
    border-top: 5px solid #fff;
    border-left: 5px solid #fff;
  }
  .QA-body .icons {
    position: absolute;
    top: 12px;
    left: 22px;
  }
  .qmask {
    display: inline-block;
    width: 28px;
    height: 28px;
    color: #630B69;
    border-radius: 50%;
    background-color: #fff;
    text-align: center;
    line-height: 28px;
    font-size: 20px;
  }
  .qtxt {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    font-style: italic;
    margin-left: 10px;
  }
  .QA-body .questions {
    padding: 26px 10px;
    box-sizing: border-box;
    border-radius: 15px;
    background: linear-gradient(to right,rgba(255,255,255,0.34),rgba(255,255,255,0.02));
    min-height: 400px;
    margin-top: 40px;
    padding-right: 0px;
  }
  .triangle {
    width: 0px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #ffffff;
    transform: rotate(180deg);
  }
  .questions-item {
    color: #ffffff;
    position: relative;
    border-bottom: 1px solid #ffffff;
    padding-right: 40px;
    margin-top: 10px;
    min-height: 62px;
    overflow: hidden;
    padding-bottom: 10px;
  }
  .item-title {
    font-size: 14px;
    text-align: justify;
  }
  .questions-item .play-txt {
    display: inline-block;
    color: #75347A;
    background-color: #ffffff;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    box-sizing: border-box;
    border: 1px solid rgba(187, 187, 187, 100);
    border-radius: 50px;
    margin-left: -3px;
  }
  .item-answer {
    border-radius: 15px;
    background-color: #85138A;
    margin: 0 auto;
    font-size: 12px;
    padding: 10px;
    margin-top: 10px;
  }
  .answer-box {
    margin-top: 10px;
    height: auto;
  }
  .arrowRotate {
    animation: arrowRotate 0.5s linear 1;
    transform: rotate(0deg);
  }
  .arrowRotateBack {
    animation: arrowRotateBack 0.5s linear 1;
    transform: rotate(180deg);
  }
  @keyframes arrowRotate {
    0% {transform: rotate(180deg);}
    50% {transform: rotate(90deg);}
    100% {transform: rotate(0deg);}
  }
  @keyframes arrowRotateBack {
    0% {transform: rotate(0deg);}
    50% {transform: rotate(90deg);}
    100% {transform: rotate(180deg);}
  }
  .heightBig {
    animation: heightBig 0.5s linear 1;
    height: auto;
  }
  .heightSmall {
    animation: heightSmall 0.5s linear 1;
    height: 0px;
  }
  @keyframes heightBig {
    0% {height: 0;}
    100% {height: auto;}
  }
  @keyframes heightSmall {
    0% {height: 150px;}
    100% {height: 0;}
  }
</style>



// WEBPACK FOOTER //
// src/components/myPkFit/Q&A.vue